document.addEventListener('DOMContentLoaded', () => {
  const viewerContainers = document.querySelectorAll('.cosmic-live-viewers');
  
  viewerContainers.forEach(container => {
    const min = parseInt(container.getAttribute('data-min')) || 12;
    const max = parseInt(container.getAttribute('data-max')) || 25;
    const countEl = container.querySelector('.viewer-count');
    
    if (!countEl) return;
    
    // Initial random value
    let currentViewers = Math.floor(Math.random() * (max - min + 1)) + min;
    countEl.textContent = currentViewers;
    
    // Periodically update the value randomly every 5 to 15 seconds
    const updateViewers = () => {
      // Chance to increase or decrease
      const change = Math.floor(Math.random() * 3) - 1; // -1, 0, or 1
      currentViewers += change;
      
      // Clamp between min and max
      if (currentViewers < min) currentViewers = min;
      if (currentViewers > max) currentViewers = max;
      
      // Flash effect to show it updated
      countEl.style.color = '#E83F3F';
      countEl.style.transform = 'scale(1.1)';
      countEl.textContent = currentViewers;
      
      setTimeout(() => {
        countEl.style.color = '';
        countEl.style.transform = '';
      }, 500);
      
      const nextUpdate = Math.floor(Math.random() * 8000) + 4000; // 4s to 12s
      setTimeout(updateViewers, nextUpdate);
    };
    
    setTimeout(updateViewers, Math.floor(Math.random() * 4000) + 2000);
  });
});
